import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div
      className="min-h-[85svh] flex items-center justify-center pt-32 pb-24 container-lux text-center"
      data-testid="payment-cancel-page"
    >
      <div className="max-w-lg">
        <p className="label-mono text-mineral mb-6">Checkout cancelled</p>
        <h1 className="heading-serif text-4xl md:text-5xl tracking-wider mb-8 leading-tight">
          Your bag awaits
        </h1>
        <p className="text-alabaster/70 mb-10 leading-relaxed">
          No payment was taken. Your selected fragrances remain safely in your bag whenever you are
          ready to complete your order.
        </p>
        <Link
          to="/collection"
          data-testid="cancel-return-btn"
          className="btn-relic border-alabaster bg-alabaster text-charcoal hover:bg-amethyst hover:border-amethyst"
        >
          Return to the Collection
        </Link>
      </div>
    </div>
  );
}
